export const STATUS_LEGEND_TITLES = {
  Critical: 'A machine failure could be imminent. Please investigate as soon as possible.',
  High: 'A moderate phase of wear has been reached. It is recommended to begin preparing for repairs by ordering parts and scheduling labor and downtime.',
  Standard:
    'There is an opportunity to extend equipment life with adjustments in lubrication, cleaning, routine maintenance, or operational practices.',
  'no ai': 'An action item does not exist, and the equipment is not showing any potential issues.',
  Watchlist:
    'An action item has not been created for the equipment, but Waites analysts are currently monitoring the data (and may open an action item if necessary). The Facility Technicians can proactively inspect this equipment if they have time, but Waites analysts have not yet made a formal recommendation.',
  Inactive:
    'The equipment has an installation point that is not yet associated with a sensor or has been deactivated.',
  on_hold: 'An action item has been snoozed by a facility technician until a user-specified date.',
};
